import { ListItemText } from '@mui/material'
import { useRef, useState } from 'react'
import { useParams } from 'react-router'
import { useMessageSource } from 'src/i18n/useMessageSource'
import { EXPORT_FORMAT } from 'src/shared/constants/constants'
import { ExportMenu } from 'src/shared/menu/ExportMenu'
import { LoadingMenuItem } from 'src/shared/menu/item/LoadingMenuItem'
import { S } from 'src/shared/styled/S'
import { downloadFileByUrl } from 'src/shared/utils/BlobUtils'
import { useNotificationService } from 'src/shared/utils/NotificationService'
import { useUserLocale } from 'src/user/UserContext'

export const FinalProgramReportExportMenu = () => {
  const { getMessage } = useMessageSource()
  const { programId } = useParams()
  const language = useUserLocale()
  const notificationService = useNotificationService()

  const exportMenuRef = useRef<{ closeMenu: () => void }>({
    closeMenu: () => {},
  })

  const [loadingExportFinalProgramReport, setLoadingExportFinalProgramReport] = useState(false)

  const handleExportKapProgram = () => {
    setLoadingExportFinalProgramReport(true)
    downloadFileByUrl(`api/kap/program/${programId}/milestone/final-report/export?lang=${language}`)
      .then(() => exportMenuRef.current.closeMenu())
      .catch(() => notificationService.operationFailed())
      .finally(() => setLoadingExportFinalProgramReport(false))
  }

  return (
    <ExportMenu ref={exportMenuRef}>
      <LoadingMenuItem
        loading={loadingExportFinalProgramReport}
        disabled={loadingExportFinalProgramReport}
        onClick={handleExportKapProgram}
      >
        <ListItemText>{getMessage('label.export.final.report')}</ListItemText>
        <S.Typography.ExportFormat>({EXPORT_FORMAT.WORD})</S.Typography.ExportFormat>
      </LoadingMenuItem>
    </ExportMenu>
  )
}
